<template>
  <div class="wb-app-container" v-on:click="openOverlay(null)">
    <div class="wb-app-loader" ref="appLoader" v-if="appWideProgress < 100">
      <div class="wb-app-loader--title">Управляй пространством</div>
      <img src="assets/loaderShort.gif" />
      <div class="wb-app-loader--info">{{ appWideProgress }}%</div>
    </div>
    <input type='file' id="fileInput" @change="loadProject" ref="fileInput" accept='.json' />
    <div v-if="storeUI.loader" class="loader">
      <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
    <OverlayDoorParams :top="'calc(100% - 120px)'"
                       :left="'calc(50% + 76px)'"
                       :data="storeUI.getSelectedDoor"
                       v-if="isSelectedDoor(storeUI.getSelectedSceneObject)"
                       :open-element-color-overlay="openOverlay"/>
    <OverlayBoxParams :top="'calc(100% - 120px)'"
                       :left="'calc(50% + 76px)'"
                       :data="storeUI.getSelectedBox"
                       v-if="isSelectedBox(storeUI.getSelectedSceneObject)"
                       :open-element-color-overlay="openOverlay"/>

    <OverlayElementInfo :top="'calc(100% - 120px)'"
                        :left="'calc(50% + 76px)'"
                        :data="storeUI.getSelectedSceneObject"
                        v-if="isSelectedElement(storeUI.getSelectedSceneObject)"
                        :open-element-color-overlay="openOverlay"/>
    <OverlayElementColor :method="setColor"
                         v-if="isOverlayElementColor"
                         :top="60"
                         :left="294"
    />
    <OverlayColorPicker :categories-prop="storeData.getWallColorCategories"
                        :type="'wall'"
      :selected-category="configurationStore.getRoomParamByName('selectedWallCategory')"
      :selected-color="configurationStore.getRoomParamByName('selectedWallColor')"
                        :options-prop="storeData.getWallColorOptions"
                        :top="60"
                        :left="35"
                        v-if="isOverlayWall"/>
    <OverlayColorPicker :categories-prop="storeData.getFloorColorCategories"
                        :type="'floor'"
      :selected-category="configurationStore.getRoomParamByName('selectedFloorCategory')"
      :selected-color="configurationStore.getRoomParamByName('selectedFloorColor')"
                        :options-prop="storeData.getFloorColorOptions"
                        :top="60"
                        :left="99"
                        v-if="isOverlayFloor"/>
    <!--        <OverlaySelectedDnD v-if="storeData.getElementDnd"-->
    <!--                            :element="storeData.getElementDnd"/>-->
    <OverlayRoomSetup v-if="storeUI.getMode === 'room'" />

    <OverlayTooltips v-if="storeUI.getMode === 'wardrobe'" v-show="storeUI.getIsTooltip" />
    <OverlayTooltipsButton v-if="storeUI.getMode === 'wardrobe'" />
    <OverlayScreen v-if="isScreenVisible" @is-visible-modal="isScreenVisible = !isScreenVisible" />

    <!--        <div class="wb-v3d-container"></div>-->
    <div id="v3d-container" class="wb-v3d-container"></div>
    <div class="wb-app-interface"
         v-if="storeUI.getMode === 'wardrobe'">
      <TheNavbar :open-overlay="openOverlay"
                 :is-result-sidebar="isResultSidebar"
                 :open-result-sidebar="openResultSidebar"
                 :isScreenVisible="isScreenVisible"
                 :is-overlay-floor="isOverlayFloor"
                 :is-overlay-wall="isOverlayWall"
                 @is-visible-modal="isScreenVisible = !isScreenVisible"
      />
      <div class="wb-sidebars">
        <div class="wb-sidebar-container" v-on:click.stop="">
          <TheSidebarCategories :open-sidebar-menu="openSidebarMenu"
                                :construction-categories="storeData.getConstructionCategories"
                                :categories="categoriesForMenu"/>
          <TheSidebarMenu v-if="storeUI.getIsSidebarMenu"/>
        </div>
        <div class="wb-sidebar-container"  v-show="isResultSidebar" v-on:click.stop="">
          <TheSidebarResult/>
        </div>
      </div>

    </div>

    <!--TODO color picker-->
    <!--        <ColorPicker :position="['10px', '10px']" :onSelect="onColorPickerSelect"/>-->
  </div>
</template>

<script>
import initVerge from '../initVerge';
import { useUIOnlyStore } from '@/Store/storeUI';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import ColorPicker from './Components/ColorPicker';
import TheNavbar from '@/UI/Components/TheNavbar.vue';
import TheSidebarCategories from '@/UI/Components/TheSidebarCategories.vue';
import TheSidebarMenu from '@/UI/Components/TheSidebarMenu.vue';
import OverlayColorPicker from '@/UI/Components/ComponentsOverlay/OverlayColorPicker.vue';
import { floorColorCategories, floorColorOptions, wallColorCategories, wallColorOptions } from '@/Constants/demoData';
import TheSidebarResult from '@/UI/Components/TheSidebarResult.vue';
import OverlayElementInfo from '@/UI/Components/ComponentsOverlay/OverlayElementInfo.vue';
import OverlayElementColor from '@/UI/Components/ComponentsOverlay/OverlayElementIColor.vue';
import OverlayDoorParams from '@/UI/Components/ComponentsOverlay/OverlayDoorParams.vue';
import { useStoreData } from '@/Store/storeData';
import { demo } from '@/Constants/demoCatalog';
// import OverlaySelectedDnD from '@/UI/Components/ComponentsOverlay/OverlaySelectedDnD.vue';
import OverlayRoomSetup from '@/UI/Components/ComponentsOverlay/OverlayRoomSetup.vue';
import OverlayTooltips from '@/UI/Components/ComponentsOverlay/OverlayTooltips.vue';
import OverlayTooltipsButton from '@/UI/Components/ComponentsOverlay/OverlayTooltipsButton.vue';
import { saveProject } from '@/lib/saveProject';
import OverlayScreen from '@/UI/Components/ComponentsOverlay/OverlayScreen.vue';
import { requestJson, requestJsonGet } from '../utils/httpRequest';
import { onMessageHandler, sendOnLoadedStatus } from '@/utils/postmessages';
import { configurationStoreDefaultState, demoConfiguration } from '@/Constants/configurationStoreDefaultState';
import { deleteEl } from '@/lib/deleteEl';
import { $ } from '@/Engine/state';
import { ref } from 'vue';
import { load } from '../../opentype';
import { updatePresetData } from '@/lib/updatePresetData';
import { EventBus } from '@/utils/eventBus';
import AssetsLoadProgress from '@/mixins/AssetsLoadProgress';
import { calculateAppWideProgress } from '@/utils/calculateAppWideProgress';
import OverlayBoxParams from '@/UI/Components/ComponentsOverlay/OverlayBoxParams.vue';

export default {
  name: 'App',
  components: {
    OverlayBoxParams,
    OverlayScreen,
    OverlayTooltipsButton,
    OverlayTooltips,
    OverlayRoomSetup,
    // OverlaySelectedDnD,
    OverlayDoorParams,
    OverlayElementColor,
    OverlayElementInfo,
    TheSidebarResult,
    OverlayColorPicker,
    TheSidebarMenu,
    TheSidebarCategories,
    TheNavbar,
    // ColorPicker,
  },
  setup() {
    const fileInput = ref(null);
    const appLoader = ref(null);
    const configurationStore = useConfigurationStore();
    const storeUI = useUIOnlyStore();
    const storeData = useStoreData();
    return {
      configurationStore,
      storeUI,
      storeData,
      fileInput,
      appLoader,
    };
  },
  provide() {
    return {
       currencySymbol: this.getCurrencySymbol(),
       externalUser: this.getExternalUser(),
     };
  },
  mixins: [ AssetsLoadProgress ],
  data: function() {
    return {
      appWideProgress: 0,
      init: false,
      isVertical: false,
      floorColorCategories: floorColorCategories,
      floorColorOptions: floorColorOptions,
      wallColorCategories: wallColorCategories,
      wallColorOptions: wallColorOptions,
      isOverlayWall: false,
      isOverlayFloor: false,
      isOverlayElementColor: false,
      isScreenVisible: false,
      isResultSidebar: false,
      createdTimeMs: null,
      currentTimeMs: null,
    };
  },
  created() {
    EventBus.on('update-progress', (progress) => {
      if (progress > this.appWideProgress) {
        this.appWideProgress = progress;
      }
    });
    this.createdTimeMs = (new Date()).getTime();
    setInterval(() => {
      this.currentTimeMs = (new Date()).getTime();
    }, 100);
  },
  beforeUnmount() {
    EventBus.off('update-progress');
  },
  computed: {
    spentTimeMs() {
      return this.currentTimeMs - this.createdTimeMs;
    },
    categoriesForMenu() {
      let dataIn = JSON.parse(JSON.stringify(this.storeData.getCategories));
      // const removeIndex = dataIn.findIndex((item) => item.name === 'Крепления');
      //
      // if (removeIndex > -1) {
      //     dataIn.splice(removeIndex, 1);
      // }
      //
      // const itemToFirstPositionIndex = dataIn.findIndex((item) => item.name === 'Готовые решения');
      //
      // if (itemToFirstPositionIndex > -1) {
      //     const itemToFirstPosition = JSON.parse(JSON.stringify(dataIn[itemToFirstPositionIndex]));
      //     dataIn.splice(itemToFirstPositionIndex, 1);
      //     dataIn.unshift(itemToFirstPosition);
      // }

      // TODO temp
      let removeIndex = dataIn.findIndex((item) => item.name === 'Крепления');

      if (removeIndex > -1) {
        dataIn.splice(removeIndex, 1);
      }
      // TODO end temp

      return dataIn.sort((category1,category2)=>category1.sort-category2.sort);
    },
  },
  methods: {
    load,
    deleteEl,
    keyDownHandler(event) {
      if (event.keyCode === 8 || event.keyCode === 46) {
        this.deleteEl();
      }
      if ((event.metaKey||event.ctrlKey) && event.code === 'KeyZ') {
        event.shiftKey?this.configurationStore.redo():this.configurationStore.undo();
      }
    },
    setColor(value) {
      this.configurationStore.setMainColor(value);
      this.openOverlay(null);
      // TODO костыль, т.к. с первого раза не применяется цвет ко всему шкафу
      setTimeout(()=>{
        this.configurationStore.setMainColor(value);
      }, 100);
    },
    onColorPickerSelect(hex) {
      this.configurationStore.setWardrobeBaseColor(hex);
    },
    isSelectedDoor(el) {
      return el.uuid && [ 'Дверь', 'Окно' ].includes(el.label);
    },
    isSelectedBox(el) {
      return el.uuid && el.label === 'Куб';
    },
    isSelectedElement(el) {
      return el.label && [
        'Полка сетчатая',
        'Штанга',
        'Брючница выдвижная',
        'Обувница',
        'Полка ЛДСП',
        'Корзина мелкосетчатая',
        'Корзина пластиковая',
      ].some((element) =>
        el.label.includes(element),
      );
      // return el.uuid && [
      //   'Полка сетчатая',
      //   'Штанга',
      //   'Брючница выдвижная',
      //   'Обувница',
      //   'Полка ЛДСП',
      //   'Корзина мелкосетчатая',
      //   'Корзина пластиковая',
      // ].includes(el.label);
    },
    openOverlay(name) {
      //TODO click outside close overlays
      let returnFlag = false;
      const rule = {
        wall: 'isOverlayWall',
        floor: 'isOverlayFloor',
        element: 'isOverlayElementColor',
        resultSidebar: 'isResultSidebar',
      };
      for (let item of Object.values(rule)) {
        if (this[item] && rule[name] === item) {
          returnFlag = true;
        }
        this[item] = false;
      }
      if (!returnFlag) {
        this[rule[name]] = true;
      }
      //Off catalog overlay
      this.storeData.setActiveCategory(this.storeData.getActiveCategoriesSection, this.storeData.getActiveCategory);
    },
    openResultSidebar() {
      this.configurationStore.addKit($.wardrobe.raw);
      this.isResultSidebar = !this.isResultSidebar;
    },
    openSidebarMenu() {
      this.isSidebarMenu = !this.isSidebarMenu;
    },
    async openPreset(data) {
      const { presetId, projectId, projectsPath } = v3d.AppUtils.getPageParams();
      if (presetId) {
        const item = data.items.find(item => +item.id === +presetId);
        if (!item) {
          return;
        }
        const configurationStoreFromItem = await requestJson(item.url);
        updatePresetData(configurationStoreFromItem.wardrobe);
        this.configurationStore.$patch(configurationStoreFromItem);
        this.storeUI.setMode('wardrobe');
      }

      if (projectId) {
        let path = projectsPath ?? '/api/configurator/projects/';
        const project = await requestJsonGet(path + '?action=get&id=' + projectId);
        console.log(project);
        const projectData = project.data.json;
        const accessoriesData = project.data.accessories;
        if (projectData) {
          if (typeof projectData === 'string')
          {
            const data = JSON.parse(projectData);
            updatePresetData(data.wardrobe);
            this.configurationStore.$patch(data);
          } else {
            updatePresetData(projectData.wardrobe);
            this.configurationStore.$patch(projectData);
          }
          this.configurationStore.setProjectName(project.data.name);
        }

        if (accessoriesData) {
          if (typeof accessoriesData === 'string')
          {
            const data = JSON.parse(accessoriesData);
            this.storeData.setAccessories(data);
          } else {
            this.storeData.setAccessories(accessoriesData);
          }
        }

        this.storeUI.setMode('wardrobe');

      }
    },
    loadProject(e) {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.readAsText(file, 'UTF-8');
      reader.onload = readerEvent => {
        const content = JSON.parse(readerEvent.target.result);
        this.configurationStore.$patch(content);};
    },
    getCurrencySymbol() {
        const { currencySymbol } = v3d.AppUtils.getPageParams();

        return currencySymbol ? currencySymbol : '₽';
    },
    getExternalUser() {
        const { externalUser } = v3d.AppUtils.getPageParams();

        return externalUser === '1' ? true : false;
    },
  },
  watch: {
    assetsLoadingPercent(val) {
      EventBus.emit('update-progress', calculateAppWideProgress('#process1#', this.assetsLoadingPercent, true));
    },
  },
  mounted: async function() {
    localStorage.setItem('projectHistory', JSON.stringify([]));
    window.save = saveProject;
    window.load=(projectData)=>{
      this.fileInput.click();
      };
    await initVerge();
    EventBus.emit('update-progress', 95);

    const { modelsPath } = v3d.AppUtils.getPageParams();
    EventBus.emit('update-progress', 100);
    // this.storeData.receiveCatalog(JSON.parse(JSON.stringify(demo))?.data);
    //https://praktik-home.dev2.nowmedia.ru/
    const { data } = await requestJson(modelsPath ?? '/api/configurator/models/');
    // console.log(data);
    if (!data) {
      return;
    }
    this.storeData.receiveCatalog(data);
    await this.openPreset(data);

    document.addEventListener('keydown',this.keyDownHandler);
    window.addEventListener('message', onMessageHandler,false);
    sendOnLoadedStatus(100);
  },
  beforeUnmount() {
    document.removeEventListener('keydown',this.keyDownHandler);
  },
  unmounted() {
    // window.removeEventListener('message', onMessageHandler);
  },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";

.wb-app-container {
  width: 100%;
  height: 100%;

  //TODO temp
  //background-color: lightpink;
}

.wb-app-loader {
  position: absolute;
  z-index: 7;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
  text-align: center;
  width: 250px;
  min-height: 202px;
  img {
    margin: 41px 0 46px;
  }
  &--title {
    font-size: 18px;
    font-family: Montserrat;
    color: #2d3843;
  }
  &--info {
    font-size: 24px;
    font-family: Montserrat;
    font-weight: 700;
    color: #2d3843;
  }
}

.wb-app-interface {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.wb-sidebars {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  justify-content: space-between;
}

.wb-sidebar-container {
  display: flex;
  flex-direction: row;
  height: calc(100% - 64px);
  width: max-content;
  position: relative;
  z-index: 10;
}

.wb-v3d-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: $gray2;
  box-sizing: border-box;
  z-index: 2;
}

.loader {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1000;
  backdrop-filter: blur(10px);
  background-color: #00000070;
}
#fileInput{
  display: none;
}
.lds-spinner {
  color: #FFFFFF;
  //display: inline-block;
  position: absolute;
  left: calc(50% - 40px);
  top: calc(50% - 40px);
  width: 80px;
  height: 80px;
  z-index: 2000;
  transform: scale(3);
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: #fff;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
